import { combineReducers } from 'redux';
import {
  SET_SHOPPING_ICON_ELEMENT_FILE_INFO,
  SET_SHOPPING_ICON_ELEMENT_ICON_SIZE,
  SET_SHOPPING_ICON_ELEMENT_ICON_COLOR,
  SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR,
} from '../actions/action-names';

const fileInfo = (state = {}, action) => {
  switch(action.type) {
    case SET_SHOPPING_ICON_ELEMENT_FILE_INFO:
      return {
        ...state,
        ...action.value,
        originalContent: action.value.content,
        content: action.coloredContent
      };
    case SET_SHOPPING_ICON_ELEMENT_ICON_COLOR:
      return {
        ...state,
        content: action.coloredContent
      };
    default:
      return state;
  }
};

const iconSize = (state = '32px', action) => {
  switch(action.type) {
    case SET_SHOPPING_ICON_ELEMENT_ICON_SIZE:
      return action.value;
    default:
      return state;
  }
};

const iconColor = (state = 'green', action) => {
  switch(action.type) {
    case SET_SHOPPING_ICON_ELEMENT_ICON_COLOR:
      return action.value;
    default:
      return state;
  }
};

const textColor = (state = 'white', action) => {
  switch(action.type) {
    case SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR:
      return action.value;
    default:
      return state;
  }
};

export default combineReducers({
  fileInfo,
  iconSize,
  iconColor,
  textColor,
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/shopping-icon-element-options-reducers.js